"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_native_in_app_review_1 = __importDefault(require("react-native-in-app-review"));
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const react_native_permissions_1 = require("react-native-permissions");
const react_native_config_1 = __importDefault(require("react-native-config"));
class Helper {
    static packageName = "com.nextep.elevate";
    static playStoreUrl = `https://play.google.com/store/apps/details?id=${Helper.packageName}&hl=en_US&gl=US`;
    static bundleId = "6449500670";
    static appStoreUrl = `https://apps.apple.com/us/app/nextep/id${Helper.bundleId}`;
    static isPlatformWeb = react_native_1.Platform.OS === 'web';
    static webPlatform() {
        let userAgent = globalThis.navigator.userAgent;
        if (/Android/i.test(userAgent)) {
            return 'android';
        }
        else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            return 'ios';
        }
        else {
            return 'unknown';
        }
    }
    static getRoutePath = (state, previous = null) => {
        if (!('index' in (state ?? {})))
            return '';
        let r = state.routes[state.index];
        let n = (previous ? previous + '/' : '') + r.name;
        if (r.state)
            return this.getRoutePath(r.state, n);
        return n;
    };
    static getErrorData = () => {
        var data = {
            severity: 'ERROR',
            application: 'Elevate',
            platform: react_native_1.Platform.OS,
            apiUrl: react_native_config_1.default.API_URL,
            localTime: (new Date()).toString(),
            screenWidth: react_native_1.Dimensions?.get('window')?.width,
            screenHeight: react_native_1.Dimensions?.get('window')?.height,
        };
        if (react_native_1.Platform.OS == 'web') {
            data = {
                ...data,
                origin: globalThis?.location?.origin,
                path: globalThis?.location?.pathname,
                userAgent: globalThis?.navigator?.userAgent,
                language: globalThis?.navigator?.language,
            };
        }
        else {
            let language = null;
            if (react_native_1.Platform.OS == 'ios') {
                language = react_native_1.NativeModules?.SettingsManager?.settings?.AppleLanguages?.[0];
            }
            else if (react_native_1.Platform.OS == 'android') {
                language = react_native_1.NativeModules?.I18nManager?.localeIdentifier;
            }
            data = {
                ...data,
                language: language,
                appVersion: react_native_device_info_1.default.getVersion(),
                deviceType: react_native_device_info_1.default.getDeviceType(),
                deviceName: react_native_device_info_1.default.getDeviceNameSync(),
                deviceModel: react_native_device_info_1.default.getModel(),
                systemVersion: react_native_device_info_1.default.getSystemVersion(),
            };
        }
        return data;
    };
    static Months = [
        "January", "February", "March",
        "April", "May", "June",
        "July", "August", "September",
        "October", "November", "December"
    ];
    static stateAbbreviations = {
        AL: 'Alabama',
        AK: 'Alaska',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DC: 'District of Columbia',
        DE: 'Delaware',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming'
    };
    static stateNames = (() => Object.keys(Helper.stateAbbreviations).reduce((map, state) => {
        map[Helper.stateAbbreviations[state]] = state;
        return map;
    }, {}))();
    static dropdownStateAbbr = (() => Object.keys(Helper.stateAbbreviations).map((state) => ({
        label: state,
        value: state
    })))();
    static deviceLanguage() {
        let lang = null;
        switch (react_native_1.Platform.OS) {
            case 'ios':
                lang = react_native_1.NativeModules?.SettingsManager?.settings?.AppleLanguages?.[0];
                break;
            case 'android':
                lang = react_native_1.NativeModules?.I18nManager?.localeIdentifier;
                break;
            default:
                lang = globalThis?.navigator?.language;
                break;
        }
        if (lang?.includes("_")) {
            lang = lang.split("_").join("-");
        }
        if (lang?.includes("#")) {
            lang = lang.replace(/#/g, '');
        }
        return lang || "en-us";
    }
    ;
    static isWinter() {
        return new Date().getMonth() >= 11 || new Date().getMonth() <= 1;
    }
    static isSummer() {
        return new Date().getMonth() >= 2 && new Date().getMonth() <= 7;
    }
    static isAutumn() {
        return new Date().getMonth() >= 8 && new Date().getMonth() <= 10;
    }
    static GetStateName(abbreviation) {
        return this.stateAbbreviations[abbreviation] ?? abbreviation;
    }
    static GetStateAbbreviation(name) {
        return this.stateNames[name] ?? name;
    }
    static ToTitleCase(str) {
        return str.toLowerCase().split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    static FormatDate(dateString, alwaysShowYear = true) {
        const showYear = new Date(dateString).getFullYear() != new Date().getFullYear() || alwaysShowYear;
        return new Date(dateString).toLocaleDateString(Helper.deviceLanguage(), { month: 'short', ...showYear ? { year: "numeric" } : null, day: 'numeric', timeZone: 'UTC' });
    }
    static FormatTime(dateTimeString, alwaysShowYear = false) {
        const showYear = new Date(dateTimeString).getFullYear() != new Date().getFullYear() || alwaysShowYear;
        return new Date(dateTimeString).toLocaleTimeString(Helper.deviceLanguage(), { hour: '2-digit', minute: '2-digit' });
    }
    static isDateWithinDays(dateString, days) {
        const [year, month, day] = dateString.split('-').map(Number);
        const inputDate = new Date(year, month - 1, day, 0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diffTime = Math.abs(today.getTime() - inputDate.getTime());
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays <= days;
    }
    static isDateInPast(dateString) {
        const [year, month, day] = dateString.split('-').map(Number);
        const inputDate = new Date(year, month - 1, day, 0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate.getTime() < today.getTime();
    }
    static FormatCurrency(n, digits = 2) {
        if (n == null)
            n = 0;
        let r = /(\d)(?=(\d{3})+(?!\d))/g;
        let hasNegative = n < 0;
        n = Math.abs(n);
        var formatted = '$' + n.toFixed(digits).replace(r, '$1,');
        if (hasNegative)
            formatted = '-' + formatted;
        return formatted;
    }
    static FormatPercent(n) {
        if (n == null)
            n = 0;
        return n + '%';
    }
    static FormatTitleCase(text) {
        return text.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }
    static MaskCurrency(text, digits = 2) {
        text = text.replace(/[^0-9.]/g, ''); // Allow numbers and decimals.
        if (text !== "0")
            text = text.replace(/^0+/, ''); // Remove leading zero.
        let i = text.indexOf('.');
        if (i >= 0) {
            // If there is at least one decimal remove all decimals.
            text = text.replaceAll('.', '');
            // Add one decimal back with up to two digits after it.
            text = text.substr(0, i) + '.' + text.substr(i, digits);
        }
        return text;
    }
    // Show the native in-app review prompt if appropriate
    static async handleReviewPrompt() {
        const isFirstSession = await async_storage_1.default.getItem('isFirstSession');
        // Make sure it is not the user's first session
        if (isFirstSession === 'no' && react_native_1.AppState.currentState === 'active') {
            // Determine when/if the last review request was
            const lastReviewReq = Number(await async_storage_1.default.getItem('lastReviewReq'));
            const today = new Date().setHours(0, 0, 0, 0);
            // Determine if a review has been requested within 30 days (Apple dhas no built-in interval limit)
            if (lastReviewReq) {
                const diffTime = Math.abs(today - lastReviewReq);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (diffDays >= 180) {
                    await react_native_in_app_review_1.default.RequestInAppReview();
                    await async_storage_1.default.setItem('lastReviewReq', today.toString());
                }
            }
            else {
                await react_native_in_app_review_1.default.RequestInAppReview();
                await async_storage_1.default.setItem('lastReviewReq', today.toString());
            }
        }
    }
    static async verifyNotificationPermissions() {
        if (react_native_1.Platform.OS === 'ios' || react_native_1.Platform.OS === 'android') {
            const { status } = await (0, react_native_permissions_1.checkNotifications)();
            if (status === react_native_permissions_1.RESULTS.DENIED || status === react_native_permissions_1.RESULTS.BLOCKED) {
                const { status: newStatus } = await (0, react_native_permissions_1.requestNotifications)(['alert', 'sound', 'badge']);
                return newStatus === react_native_permissions_1.RESULTS.GRANTED;
            }
            return status === react_native_permissions_1.RESULTS.GRANTED;
        }
        return false;
    }
    static async verifyLocationPermissions() {
        if (react_native_1.Platform.OS == "ios") {
            const p = await (0, react_native_permissions_1.check)(react_native_permissions_1.PERMISSIONS.IOS.LOCATION_WHEN_IN_USE);
            if (p == react_native_permissions_1.RESULTS.DENIED)
                await (0, react_native_permissions_1.request)(react_native_permissions_1.PERMISSIONS.IOS.LOCATION_WHEN_IN_USE);
        }
        else if (react_native_1.Platform.OS == "android") {
            const p = await (0, react_native_permissions_1.checkMultiple)([react_native_permissions_1.PERMISSIONS.ANDROID.ACCESS_COARSE_LOCATION, react_native_permissions_1.PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION]);
            if (p[react_native_permissions_1.PERMISSIONS.ANDROID.ACCESS_COARSE_LOCATION] == react_native_permissions_1.RESULTS.DENIED)
                await (0, react_native_permissions_1.requestMultiple)([react_native_permissions_1.PERMISSIONS.ANDROID.ACCESS_COARSE_LOCATION, react_native_permissions_1.PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION]);
        }
    }
    static normalizePayPeriod(period) {
        switch (period) {
            case 'H':
            case 'D':
            case 'W':
            case 'B':
            case 'S':
            case 'M':
            case 'Y':
                return period;
            default:
                return 'Y';
        }
    }
    static periodsInYear(period) {
        switch (period) {
            case 'D': return 260;
            case 'W': return 52;
            case 'B': return 26;
            case 'S': return 24;
            case 'M': return 12;
            case 'Y': return 1;
            default: return 1;
        }
    }
    static annualizePay(payRate, payMethod, payPeriod) {
        const rate = Number(payRate ?? 0);
        if (!rate || Number.isNaN(rate))
            return 0;
        const p = (payMethod === 'H' || payPeriod === 'H') ? 'H' : (payPeriod || 'Y');
        const mult = p === 'H' ? 2080 :
            p === 'W' ? 52 :
                p === 'B' ? 26 :
                    p === 'S' ? 24 :
                        p === 'M' ? 12 : 1;
        return rate * mult;
    }
    static payUnit(period) {
        const p = this.normalizePayPeriod(period);
        switch (p) {
            case 'H': return 'hr';
            case 'D': return 'day';
            case 'W': return 'wk';
            case 'B': return 'biwk';
            case 'S': return 'semi-mo';
            case 'M': return 'mo';
            default: return 'yr';
        }
    }
    static formatCurrency(n, decimals = 2) {
        const v = Number(n || 0);
        return v.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
    static formatUSPhone(raw) {
        if (!raw)
            return '';
        const extMatch = raw.match(/\b(?:ext\.?|x)\s*(\d+)\b/i);
        const ext = extMatch ? extMatch[1] : '';
        let d = (raw || '').replace(/\D/g, '');
        if (d.length > 10) {
            d = d.slice(-10);
        }
        if (d.length === 10) {
            const area = d.slice(0, 3);
            const mid = d.slice(3, 6);
            const last = d.slice(6);
            const base = `(${area}) ${mid}-${last}`;
            return ext ? `${base} x${ext}` : base;
        }
        if (d.length === 7) {
            return `${d.slice(0, 3)}-${d.slice(3)}`;
        }
        return raw.trim();
    }
    // Converts from base64url to base64.
    static base64FromUrl(v) {
        let base64 = v?.replace('-', '+')?.replace('_', '/');
        const padding = base64.length % 4;
        if (padding !== 0)
            base64 += '='.repeat(4 - padding);
        return base64;
    }
    static hexToRgb(hex) {
        hex = hex.replace(/^#/, '');
        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return `${r},${g},${b}`;
    }
    static GetAnnouncementBodyMaxLength(isInternal) {
        return isInternal ? 200 : 800;
    }
}
exports.Helper = Helper;
